import { Component, HostBinding, input } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { Params } from '@angular/router';
import { i18nRouterLinkDirective } from '../../../../router/i18n-router-link.directive';

@Component({
  selector: 'nav-menu-link',
  templateUrl: './nav-menu-link.component.html',
  standalone: true,
  imports: [MatMenuModule, i18nRouterLinkDirective],
})
export class NavMenuLinkComponent {
  @HostBinding('class') class = 'block p-2 pl-4 lg:p-0';
  link = input.required<string | any[]>();
  params = input<Params>();
  text = input<string>();
}
